import { render } from "./HistoryItem.vue?vue&type=template&id=166dd1ed&scoped=true"
import script from "./HistoryItem.vue?vue&type=script&lang=js"
export * from "./HistoryItem.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&id=166dd1ed&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166dd1ed"]])

export default __exports__